export const TINY_SLIDER_KEY = "ldw/tiny-slider";

export const IS_BROWSER = typeof window !== "undefined";
export const YEARS_OF_EXPERIENCE =
  new Date().getFullYear() - new Date(2011, 1, 1).getFullYear();
